const _excluded = ["labelProps", "fieldProps", "inputProps", "descriptionProps", "errorMessageProps"],
  _excluded2 = ["labelProps", "fieldProps", "inputProps", "descriptionProps", "errorMessageProps"],
  _excluded3 = ["segment"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Provider as $64fa3d84918910a7$export$2881499e37b75b9a, removeDataAttributes as $64fa3d84918910a7$export$ef03459518577ad4, useContextProps as $64fa3d84918910a7$export$29f1550f4b0d4415, useRenderProps as $64fa3d84918910a7$export$4d86445c2cf5e3, useSlot as $64fa3d84918910a7$export$9d4c57ee4c6ffdd8, useSlottedContext as $64fa3d84918910a7$export$fabf2dc03a41866e } from "./utils.module.js";
import { FieldErrorContext as $ee014567cb39d3f0$export$ff05c3ac10437e03 } from "./FieldError.module.js";
import { FormContext as $d3e0e05bdfcf66bd$export$c24727297075ec6a } from "./Form.module.js";
import { Group as $a049562f99e7db0e$export$eb2fcfdbd7ba97d4, GroupContext as $a049562f99e7db0e$export$f9c6924e160136d1 } from "./Group.module.js";
import { Input as $3985021b0ad6602f$export$f5b8910cec6cf069, InputContext as $3985021b0ad6602f$export$37fb8590cf2c088c } from "./Input.module.js";
import { LabelContext as $01b77f81d0f07f68$export$75b6ee27786ba447 } from "./Label.module.js";
import { TextContext as $514c0188e459b4c0$export$9afb8bc826b033ea } from "./Text.module.js";
import { useLocale as $a9Sgq$useLocale, useDateField as $a9Sgq$useDateField, useTimeField as $a9Sgq$useTimeField, useDateSegment as $a9Sgq$useDateSegment, useFocusRing as $a9Sgq$useFocusRing, useHover as $a9Sgq$useHover, mergeProps as $a9Sgq$mergeProps } from "react-aria";
import { createCalendar as $a9Sgq$createCalendar } from "@internationalized/date";
import { useDateFieldState as $a9Sgq$useDateFieldState, useTimeFieldState as $a9Sgq$useTimeFieldState } from "react-stately";
import { filterDOMProps as $a9Sgq$filterDOMProps, useObjectRef as $a9Sgq$useObjectRef } from "@react-aria/utils";
import $a9Sgq$react, { createContext as $a9Sgq$createContext, forwardRef as $a9Sgq$forwardRef, useRef as $a9Sgq$useRef, useContext as $a9Sgq$useContext, cloneElement as $a9Sgq$cloneElement } from "react";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $40825cdb76e74f70$export$7b3e670c86da5fe8 = /*#__PURE__*/(0, $a9Sgq$createContext)(null);
const $40825cdb76e74f70$export$8e17ddc448e87c1e = /*#__PURE__*/(0, $a9Sgq$createContext)(null);
const $40825cdb76e74f70$export$3b08bebcf796eea0 = /*#__PURE__*/(0, $a9Sgq$createContext)(null);
const $40825cdb76e74f70$export$5d8dc44abd10a920 = /*#__PURE__*/(0, $a9Sgq$createContext)(null);
const $40825cdb76e74f70$export$d9781c7894a82487 = /*#__PURE__*/(0, $a9Sgq$forwardRef)(function DateField(props, ref) {
  var _ref2 = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)(props, ref, $40825cdb76e74f70$export$7b3e670c86da5fe8);
  var _ref3 = _slicedToArray(_ref2, 2);
  props = _ref3[0];
  ref = _ref3[1];
  let _ref4 = (0, $64fa3d84918910a7$export$fabf2dc03a41866e)((0, $d3e0e05bdfcf66bd$export$c24727297075ec6a)) || {},
    formValidationBehavior = _ref4.validationBehavior;
  var _props_validationBehavior, _ref;
  let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
  let _ref5 = (0, $a9Sgq$useLocale)(),
    locale = _ref5.locale;
  let state = (0, $a9Sgq$useDateFieldState)(_objectSpread(_objectSpread({}, props), {}, {
    locale: locale,
    createCalendar: $a9Sgq$createCalendar,
    validationBehavior: validationBehavior
  }));
  let fieldRef = (0, $a9Sgq$useRef)(null);
  let _ref6 = (0, $64fa3d84918910a7$export$9d4c57ee4c6ffdd8)(),
    _ref7 = _slicedToArray(_ref6, 2),
    labelRef = _ref7[0],
    label = _ref7[1];
  let inputRef = (0, $a9Sgq$useRef)(null);
  let _ref8 = (0, $a9Sgq$useDateField)(_objectSpread(_objectSpread({}, (0, $64fa3d84918910a7$export$ef03459518577ad4)(props)), {}, {
      label: label,
      inputRef: inputRef,
      validationBehavior: validationBehavior
    }), state, fieldRef),
    labelProps = _ref8.labelProps,
    fieldProps = _ref8.fieldProps,
    inputProps = _ref8.inputProps,
    descriptionProps = _ref8.descriptionProps,
    errorMessageProps = _ref8.errorMessageProps,
    validation = _objectWithoutProperties(_ref8, _excluded);
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)(_objectSpread(_objectSpread({}, (0, $64fa3d84918910a7$export$ef03459518577ad4)(props)), {}, {
    values: {
      state: state,
      isInvalid: state.isInvalid,
      isDisabled: state.isDisabled
    },
    defaultClassName: 'react-aria-DateField'
  }));
  let DOMProps = (0, $a9Sgq$filterDOMProps)(props);
  delete DOMProps.id;
  return /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $64fa3d84918910a7$export$2881499e37b75b9a), {
    values: [[$40825cdb76e74f70$export$3b08bebcf796eea0, state], [(0, $a049562f99e7db0e$export$f9c6924e160136d1), _objectSpread(_objectSpread({}, fieldProps), {}, {
      ref: fieldRef,
      isInvalid: state.isInvalid
    })], [(0, $3985021b0ad6602f$export$37fb8590cf2c088c), _objectSpread(_objectSpread({}, inputProps), {}, {
      ref: inputRef
    })], [(0, $01b77f81d0f07f68$export$75b6ee27786ba447), _objectSpread(_objectSpread({}, labelProps), {}, {
      ref: labelRef,
      elementType: 'span'
    })], [(0, $514c0188e459b4c0$export$9afb8bc826b033ea), {
      slots: {
        description: descriptionProps,
        errorMessage: errorMessageProps
      }
    }], [(0, $ee014567cb39d3f0$export$ff05c3ac10437e03), validation]]
  }, /*#__PURE__*/(0, $a9Sgq$react).createElement("div", _objectSpread(_objectSpread(_objectSpread({}, DOMProps), renderProps), {}, {
    ref: ref,
    slot: props.slot || undefined,
    "data-invalid": state.isInvalid || undefined
  })));
});
const $40825cdb76e74f70$export$5eaee2322dd727eb = /*#__PURE__*/(0, $a9Sgq$forwardRef)(function TimeField(props, ref) {
  var _ref9 = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)(props, ref, $40825cdb76e74f70$export$8e17ddc448e87c1e);
  var _ref10 = _slicedToArray(_ref9, 2);
  props = _ref10[0];
  ref = _ref10[1];
  let _ref11 = (0, $64fa3d84918910a7$export$fabf2dc03a41866e)((0, $d3e0e05bdfcf66bd$export$c24727297075ec6a)) || {},
    formValidationBehavior = _ref11.validationBehavior;
  var _props_validationBehavior, _ref;
  let validationBehavior = (_ref = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : formValidationBehavior) !== null && _ref !== void 0 ? _ref : 'native';
  let _ref12 = (0, $a9Sgq$useLocale)(),
    locale = _ref12.locale;
  let state = (0, $a9Sgq$useTimeFieldState)(_objectSpread(_objectSpread({}, props), {}, {
    locale: locale,
    validationBehavior: validationBehavior
  }));
  let fieldRef = (0, $a9Sgq$useRef)(null);
  let _ref13 = (0, $64fa3d84918910a7$export$9d4c57ee4c6ffdd8)(),
    _ref14 = _slicedToArray(_ref13, 2),
    labelRef = _ref14[0],
    label = _ref14[1];
  let inputRef = (0, $a9Sgq$useRef)(null);
  let _ref15 = (0, $a9Sgq$useTimeField)(_objectSpread(_objectSpread({}, (0, $64fa3d84918910a7$export$ef03459518577ad4)(props)), {}, {
      label: label,
      inputRef: inputRef,
      validationBehavior: validationBehavior
    }), state, fieldRef),
    labelProps = _ref15.labelProps,
    fieldProps = _ref15.fieldProps,
    inputProps = _ref15.inputProps,
    descriptionProps = _ref15.descriptionProps,
    errorMessageProps = _ref15.errorMessageProps,
    validation = _objectWithoutProperties(_ref15, _excluded2);
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)(_objectSpread(_objectSpread({}, props), {}, {
    values: {
      state: state,
      isInvalid: state.isInvalid,
      isDisabled: state.isDisabled
    },
    defaultClassName: 'react-aria-TimeField'
  }));
  let DOMProps = (0, $a9Sgq$filterDOMProps)(props);
  delete DOMProps.id;
  return /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $64fa3d84918910a7$export$2881499e37b75b9a), {
    values: [[$40825cdb76e74f70$export$5d8dc44abd10a920, state], [(0, $a049562f99e7db0e$export$f9c6924e160136d1), _objectSpread(_objectSpread({}, fieldProps), {}, {
      ref: fieldRef,
      isInvalid: state.isInvalid
    })], [(0, $3985021b0ad6602f$export$37fb8590cf2c088c), _objectSpread(_objectSpread({}, inputProps), {}, {
      ref: inputRef
    })], [(0, $01b77f81d0f07f68$export$75b6ee27786ba447), _objectSpread(_objectSpread({}, labelProps), {}, {
      ref: labelRef,
      elementType: 'span'
    })], [(0, $514c0188e459b4c0$export$9afb8bc826b033ea), {
      slots: {
        description: descriptionProps,
        errorMessage: errorMessageProps
      }
    }], [(0, $ee014567cb39d3f0$export$ff05c3ac10437e03), validation]]
  }, /*#__PURE__*/(0, $a9Sgq$react).createElement("div", _objectSpread(_objectSpread(_objectSpread({}, DOMProps), renderProps), {}, {
    ref: ref,
    slot: props.slot || undefined,
    "data-invalid": state.isInvalid || undefined
  })));
});
const $40825cdb76e74f70$export$7edc06cf1783b30f = /*#__PURE__*/(0, $a9Sgq$forwardRef)(function DateInput(props, ref) {
  // If state is provided by DateField/TimeField, just render.
  // Otherwise (e.g. in DatePicker), we need to call hooks and create state ourselves.
  let dateFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$3b08bebcf796eea0);
  let timeFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$5d8dc44abd10a920);
  return dateFieldState || timeFieldState ? /*#__PURE__*/(0, $a9Sgq$react).createElement($40825cdb76e74f70$var$DateInputInner, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })) : /*#__PURE__*/(0, $a9Sgq$react).createElement($40825cdb76e74f70$var$DateInputStandalone, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});
const $40825cdb76e74f70$var$DateInputStandalone = /*#__PURE__*/(0, $a9Sgq$forwardRef)((props, ref) => {
  let _ref16 = (0, $64fa3d84918910a7$export$29f1550f4b0d4415)({
      slot: props.slot
    }, ref, $40825cdb76e74f70$export$7b3e670c86da5fe8),
    _ref17 = _slicedToArray(_ref16, 2),
    dateFieldProps = _ref17[0],
    fieldRef = _ref17[1];
  let _ref18 = (0, $a9Sgq$useLocale)(),
    locale = _ref18.locale;
  let state = (0, $a9Sgq$useDateFieldState)(_objectSpread(_objectSpread({}, dateFieldProps), {}, {
    locale: locale,
    createCalendar: $a9Sgq$createCalendar
  }));
  let inputRef = (0, $a9Sgq$useRef)(null);
  let _ref19 = (0, $a9Sgq$useDateField)(_objectSpread(_objectSpread({}, dateFieldProps), {}, {
      inputRef: inputRef
    }), state, fieldRef),
    fieldProps = _ref19.fieldProps,
    inputProps = _ref19.inputProps;
  return /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $64fa3d84918910a7$export$2881499e37b75b9a), {
    values: [[$40825cdb76e74f70$export$3b08bebcf796eea0, state], [(0, $3985021b0ad6602f$export$37fb8590cf2c088c), _objectSpread(_objectSpread({}, inputProps), {}, {
      ref: inputRef
    })], [(0, $a049562f99e7db0e$export$f9c6924e160136d1), _objectSpread(_objectSpread({}, fieldProps), {}, {
      ref: fieldRef,
      isInvalid: state.isInvalid
    })]]
  }, /*#__PURE__*/(0, $a9Sgq$react).createElement($40825cdb76e74f70$var$DateInputInner, props));
});
const $40825cdb76e74f70$var$DateInputInner = /*#__PURE__*/(0, $a9Sgq$forwardRef)((props, ref) => {
  let className = props.className,
    children = props.children;
  let dateFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$3b08bebcf796eea0);
  let timeFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$5d8dc44abd10a920);
  let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
  return /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $a9Sgq$react).Fragment, null, /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $a049562f99e7db0e$export$eb2fcfdbd7ba97d4), _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    slot: props.slot || undefined,
    className: className !== null && className !== void 0 ? className : 'react-aria-DateInput',
    isInvalid: state.isInvalid
  }), state.segments.map((segment, i) => /*#__PURE__*/(0, $a9Sgq$cloneElement)(children(segment), {
    key: i
  }))), /*#__PURE__*/(0, $a9Sgq$react).createElement((0, $3985021b0ad6602f$export$f5b8910cec6cf069), null));
});
const $40825cdb76e74f70$export$336ab7fa954c4b5f = /*#__PURE__*/(0, $a9Sgq$forwardRef)(function DateSegment(_ref20, ref) {
  let segment = _ref20.segment,
    otherProps = _objectWithoutProperties(_ref20, _excluded3);
  let dateFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$3b08bebcf796eea0);
  let timeFieldState = (0, $a9Sgq$useContext)($40825cdb76e74f70$export$5d8dc44abd10a920);
  let state = dateFieldState !== null && dateFieldState !== void 0 ? dateFieldState : timeFieldState;
  let domRef = (0, $a9Sgq$useObjectRef)(ref);
  let _ref21 = (0, $a9Sgq$useDateSegment)(segment, state, domRef),
    segmentProps = _ref21.segmentProps;
  let _ref22 = (0, $a9Sgq$useFocusRing)(),
    focusProps = _ref22.focusProps,
    isFocused = _ref22.isFocused,
    isFocusVisible = _ref22.isFocusVisible;
  let _ref23 = (0, $a9Sgq$useHover)(_objectSpread(_objectSpread({}, otherProps), {}, {
      isDisabled: state.isDisabled || segment.type === 'literal'
    })),
    hoverProps = _ref23.hoverProps,
    isHovered = _ref23.isHovered;
  let renderProps = (0, $64fa3d84918910a7$export$4d86445c2cf5e3)(_objectSpread(_objectSpread({}, otherProps), {}, {
    values: _objectSpread(_objectSpread({}, segment), {}, {
      isReadOnly: !segment.isEditable,
      isInvalid: state.isInvalid,
      isDisabled: state.isDisabled,
      isHovered: isHovered,
      isFocused: isFocused,
      isFocusVisible: isFocusVisible
    }),
    defaultChildren: segment.text,
    defaultClassName: 'react-aria-DateSegment'
  }));
  return /*#__PURE__*/(0, $a9Sgq$react).createElement("div", _objectSpread(_objectSpread(_objectSpread({}, (0, $a9Sgq$mergeProps)((0, $a9Sgq$filterDOMProps)(otherProps), segmentProps, focusProps, hoverProps)), renderProps), {}, {
    ref: domRef,
    "data-placeholder": segment.isPlaceholder || undefined,
    "data-invalid": state.isInvalid || undefined,
    "data-readonly": !segment.isEditable || undefined,
    "data-disabled": state.isDisabled || undefined,
    "data-type": segment.type,
    "data-hovered": isHovered || undefined,
    "data-focused": isFocused || undefined,
    "data-focus-visible": isFocusVisible || undefined
  }));
});
export { $40825cdb76e74f70$export$7b3e670c86da5fe8 as DateFieldContext, $40825cdb76e74f70$export$8e17ddc448e87c1e as TimeFieldContext, $40825cdb76e74f70$export$3b08bebcf796eea0 as DateFieldStateContext, $40825cdb76e74f70$export$5d8dc44abd10a920 as TimeFieldStateContext, $40825cdb76e74f70$export$d9781c7894a82487 as DateField, $40825cdb76e74f70$export$5eaee2322dd727eb as TimeField, $40825cdb76e74f70$export$7edc06cf1783b30f as DateInput, $40825cdb76e74f70$export$336ab7fa954c4b5f as DateSegment };